export function mapSection() {
    let $path;
    let $stateModals;
    let selectedStates = [];
    let $parentBlock = $(".map-frame .map-states-holder");
    let mapData = JSON.parse($parentBlock.find("svg").attr("data-map-object"));
    let countClose = 0;
    let addMapModal = function (data, modalClass, clickTarget) {
        let statisticBlock = "";
        let cta = function () {
            if (data.modalInfo.cta) {
                return data.modalInfo.cta;
            } else {
                return "";
            }
        };

        for (let a = 0; a < data.modalInfo.statisticData.length; a++) {
            let item = data.modalInfo.statisticData[a];
            statisticBlock += "<div class='value'><span class='value-number'>" + item.title + "</span><span class='value-name'>" + item.subtitle + "</span></div>";
        }

        let modalLayout = `<div class="map-state-modal">
                                <div class="modal-inner">
                                    <div class="title-block">
                                        <h4 class="modal-title">` + data.modalInfo.title + `</h4>
                                        <p class="modal-description">` + data.modalInfo.modalDesc + `</p>
                                    </div>
                                    <div class="statistic-box has-animation">
                                        <div class="row">
                                            ` + statisticBlock + `
                                        </div>
                                    </div>
                                    ` + cta() + `
                                </div>
                                <button type="button" class="modal-close"></button>
                            </div>`;

        $parentBlock.append($(modalLayout).addClass(modalClass));

        setTimeout(() => {
            if (Array.isArray(clickTarget)) { // target for region modals
                clickTarget.map((path, index) => {

                    $(path[0]).on("click", function () {
                        if ($(this).hasClass(modalClass)) {
                            $(".map-state-modal").removeClass("show");
                            $("." + modalClass).addClass("show");
                            countClose = 1;
                        }
                    });
                });
            } else { // target for pin modals
                $(".map-pin").on("click", function () {
                    if ($(this).hasClass(modalClass)) {
                        $(".map-state-modal").removeClass("show");
                        $("." + modalClass).addClass("show");
                        countClose = 1;
                    }
                });
            }
        }, 2000);
    };

    if (mapData.regions && mapData.regions.length) {

        for (let i = 0; i < mapData.regions.length; i++) {
            let items = mapData.regions[i].states;

            items.map((item, index) => {
                $path = $(".map-states").find("#" + item);

                $path.css({
                    fill: mapData.regions[i].color,
                });

                $path.addClass("has-region region" + i + "");
                selectedStates.push($path);
            });

            addMapModal(mapData.regions[i], "region" + i, selectedStates);
        }
    }

    if (mapData.pins && mapData.pins.length) {
        for (let j = 0; j < mapData.pins.length; j++) {
            let pin = "<span class='map-pin " + "pin" + j + "' style='top: " + mapData.pins[j].position.y + "; left: " + mapData.pins[j].position.x + "; background-color: " + mapData.pins[j].color + "'></span>";
            $parentBlock.append(pin);

            addMapModal(mapData.pins[j], "pin" + j, pin);
        }
    }

    $stateModals = $(".map-state-modal");

    $stateModals.on("click", ".modal-close", function () {
        $(this).closest(".map-state-modal").removeClass("show");
        countClose = 0;
    });

    $(document).keydown(function (e) {
        if (e.keyCode == 27) {
            $(".map-state-modal").removeClass("show");
        }
    });

    $("body").on("click", function (e) {
        if (!e.target.closest(".map-state-modal") && !e.target.closest(".map-pin") && !e.target.closest(".has-region") && $(".map-state-modal.show").length) {
            if (countClose > 0) {
                $(".map-state-modal").removeClass("show");
                countClose = 0;
            } else {
                countClose = 1;
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mapSection.js